import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchFaqList } from 'Components/InfoFaq/Redux/thunks';
import InfoFaq from 'Components/InfoFaq/InfoFaq';

import { 
  getIsFetchingFaq, 
  getIsFetchFaqFailed, 
  getFaqList,
} from 'Components/InfoFaq/Redux/selectors';

interface IPropsInternal {
  isFetching: boolean;
  isFetchFailed: boolean;
  faqList: Julius.Website.FAQViewModel[];
  fetchFaqList: () => void;
}

type Props = IPropsInternal;

class InfoFaqContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchFaqList();
  }

  render() {
    return (
      <InfoFaq
        isFetching={ this.props.isFetching }
        isFetchFailed={ this.props.isFetchFailed }
        faqList={ this.props.faqList }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetchingFaq(state),
    isFetchFailed: getIsFetchFaqFailed(state),
    faqList: getFaqList(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchFaqList,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoFaqContainer);


// WEBPACK FOOTER //
// ./src/components/InfoFaq/InfoFaqContainer.tsx